import { render } from "./UsersDropdown.vue?vue&type=template&id=fa13489c"
import script from "./UsersDropdown.vue?vue&type=script&lang=js"
export * from "./UsersDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__